import { reasonLabel, VERDICT_LABEL, verdictOf } from "@/shared/strategy/score";

import { ScoreBreakdown } from "./ScoreBreakdown";
import { useCycleScoreExplanation } from "./useCycleScoreExplanation";

export function CycleScoreExplanation({
  cycleId,
  enabled,
}: {
  readonly cycleId: string | null;
  readonly enabled: boolean;
}): React.JSX.Element | null {
  if (cycleId === null || !enabled) return null;
  return <LoadedCycleScoreExplanation cycleId={cycleId} />;
}

function LoadedCycleScoreExplanation({
  cycleId,
}: {
  readonly cycleId: string;
}): React.JSX.Element {
  const evidence = useCycleScoreExplanation(cycleId, true);
  if (evidence.status === "loading") {
    return <p className="col-span-full text-helper-sm text-text-muted">Загружаем обоснование Score…</p>;
  }
  if (evidence.status !== "ready" && evidence.status !== "stale") {
    return (
      <p className="col-span-full text-helper-sm text-text-muted">
        Историческое обоснование Score недоступно.
      </p>
    );
  }

  const decision = evidence.data;
  const verdict = verdictOf(decision.guard.verdict);
  const contributions = decision.contributions.map((one) => ({
    key: one.feature,
    raw_value: one.raw_value,
    normalized_value: one.normalized_value,
    weight: one.applied_weight,
    contribution: one.contribution,
  }));

  return (
    <section
      className="col-span-full mt-2 border-l-2 border-border-strong pl-3"
      data-testid={`cycle-score-explanation-${cycleId}`}
    >
      <div className="flex flex-wrap gap-x-3 gap-y-1 text-helper-sm text-text-secondary">
        <span>
          Score при входе <span className="font-mono text-text-primary">{decision.final_score}</span>
        </span>
        <span data-testid={`cycle-score-version-${cycleId}`}>{decision.score_version}</span>
        <span>{decision.evidence_level}</span>
        {verdict !== null && <span>{VERDICT_LABEL[verdict]}</span>}
        {decision.guard.reason !== null && <span>{reasonLabel(decision.guard.reason)}</span>}
      </div>
      <ScoreBreakdown symbol={cycleId} contributions={contributions} />
    </section>
  );
}
